import React, { useState } from "react";
import "./styles.css";
import ProgramMixPlanner from "./ProgramMixPlanner";
import AccountPlan from "./AccountPlan";
import OrgChart from "./OrgChart";
import ContentSyndication from "./ContentSyndication"; // Import the new file

export default function App() {
  const [activeTab, setActiveTab] = useState("mix");

  return (
    <div className="app">
      <div className="page-head">
        <h1>Coursera ABM Planner 2026</h1>
        <p>Strategic planning for Enterprise North America (NAMER)</p>

        {/* Navigation Tabs */}
        <div className="tabs" style={{ marginTop: "16px" }}>
          <button
            className={`tab ${activeTab === "mix" ? "active" : ""}`}
            onClick={() => setActiveTab("mix")}
          >
            Program Mix Planner
          </button>
          <button
            className={`tab ${activeTab === "syndication" ? "active" : ""}`}
            onClick={() => setActiveTab("syndication")}
          >
            Content Syndication
          </button>
          <button
            className={`tab ${activeTab === "plan" ? "active" : ""}`}
            onClick={() => setActiveTab("plan")}
          >
            Account Plan
          </button>
          <button
            className={`tab ${activeTab === "org" ? "active" : ""}`}
            onClick={() => setActiveTab("org")}
          >
            Buying Committee
          </button>
        </div>
      </div>

      <div style={{ marginTop: "24px" }}>
        {activeTab === "mix" && <ProgramMixPlanner />}
        {activeTab === "syndication" && <ContentSyndication />}
        {activeTab === "plan" && <AccountPlan />}
        {activeTab === "org" && <OrgChart />}
      </div>
    </div>
  );
}
